import { motion } from "framer-motion";
import { Landmark, Zap, Handshake } from "lucide-react";
import { useI18n } from "../../i18n";

const icons = [Landmark, Zap, Handshake];

export const TrustBand = () => {
  const { t } = useI18n();
  return (
    <section className="border-t border-white/10 py-16 lg:py-20" style={{ background: "rgba(255,255,255,0.02)" }} data-testid="trust-band">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.6 }}
          className="font-heading font-bold tracking-tight text-2xl lg:text-3xl mb-12"
          data-testid="trust-band-tagline"
        >
          {t("trust.tagline")} <span className="text-gold">{t("trust.taglineGold")}</span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-14">
          {t("trust.items").map((it, i) => {
            const Icon = icons[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: 0.1 + i * 0.1 }}
                className="flex items-start gap-4"
                data-testid={`trust-item-${i}`}
              >
                <Icon size={26} className="text-gold shrink-0 mt-1" strokeWidth={1.5} />
                <div>
                  <h3 className="font-heading font-semibold tracking-tight text-base text-white mb-2">{it.title}</h3>
                  <p className="text-[#8A9DB1] text-sm leading-relaxed">{it.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustBand;
